import { render, staticRenderFns } from "./ShowDetail.vue?vue&type=template&id=617a86ac&scoped=true"
import script from "./ShowDetail.vue?vue&type=script&lang=js"
export * from "./ShowDetail.vue?vue&type=script&lang=js"
import style0 from "./ShowDetail.vue?vue&type=style&index=0&id=617a86ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a86ac",
  null
  
)

export default component.exports